/** WCAG relative luminance / contrast (server-side check of the tenant colour; the UI has its own in @repo/ui). */
function channel(v: number): number {
  const c = v / 255;
  return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
}

export function luminance(hex: string): number {
  const n = parseInt(hex.replace('#', ''), 16);
  return 0.2126 * channel((n >> 16) & 255) + 0.7152 * channel((n >> 8) & 255) + 0.0722 * channel(n & 255);
}

export function contrastWithWhite(hex: string): number {
  return 1.05 / (luminance(hex) + 0.05);
}

/** White text on the primary colour must reach WCAG AA (4.5:1). */
export const MIN_PRIMARY_CONTRAST = 4.5;
